'use strict';

import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import Select from 'react-select';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import CSVFileValidator from 'csv-file-validator';
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD,getHyphenDDMMMYYYYHHMM,getHyphenDDMMMYYYY,getHyphenYYYYMMDDHHMMSS,getHyphenDDMMYYYYHHMMSS,getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils'; 
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";    
import Showlmvalue from "./showlmvalue";
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';
import { renderNoticeStrip, renderIgnoredTrucksNotice } from './truckNotices';
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent="";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;




// Separator for the grid's "<zone><sep><vehicle type>" column keys.
// ⚠ NOT "-": several warehouses have zones literally named ZONE-1 ... ZONE-6, so a hyphen made
// key.split() return 3 parts, the guard rejected the cell, and the manual-availability save then
// read NO COUNT for it - silently. Must be a sequence that cannot occur in a zone or vehicle name.
const ZONE_COL_SEP = "||";

// Column group for trucks the LSP has not earmarked to a zone. Deliberately NOT "ALL": the engine
// reads a blank zone as "usable in any zone", and a reader must be able to tell "not earmarked"
// from a zone actually named ALL. Must match ZONE_NOT_SET_LABEL in lmConsigneesController.js.
const ZONE_NOT_SET_LABEL = "ZONE NOT SET";

// Manual Availability is configured PER MODE (client, 2026-10-16). A warehouse that runs Regular
// and Hub off manual counts while Dedicated still uses the live feed must be able to say exactly
// that - one warehouse-wide tick could not. Each mode owns its OWN tick and its OWN counts grid,
// saved/loaded independently. Keys must match the Node + engine mode keys EXACTLY.
// ⚠ THE MODE IS THE TOP TAB (client, 2026-10-16) - there is deliberately NO second mode selector
// on this screen: the tab you are on IS the mode the tick and the counts belong to.
// ⚠ HUB has no data_type of its own: Regular and Hub are BOTH data_type 1 and are told apart by
// a hub flag - the same contract sobRunPanel.js codes against. `hub` here is that flag.
// Air Courier is deliberately NOT a mode: air vehicles are never allocated out of truck
// availability, so a tick for it would configure something nothing reads.
const MANUAL_MODES = [
    { key: "REGULAR",   label: "Regular",         data_type: 1, hub: false },
    { key: "HUB",       label: "Hub",             data_type: 1, hub: true  },
    { key: "DEDICATED", label: "Dedicated",       data_type: 3, hub: false },
    { key: "COURIER",   label: "Surface Courier", data_type: 2, hub: false },
];
const MANUAL_MODE_KEYS = MANUAL_MODES.map(function(m){ return m.key; });
function manualModeDef(key){
    var found = MANUAL_MODES.filter(function(m){ return m.key === key; });
    return found.length > 0 ? found[0] : MANUAL_MODES[0];
}

// A HUB truck is identified by its ZONE being a HUB NAME: the live feed reports it by SIZE
// ('32 FT Vehicle', never '32 FT HUB Vehicle'), so hub and regular trucks share one feed and are
// separated by zone - exactly the split the engine makes (sob_lsp_hub.split_hub_trucks) and the
// one sobRunPanel.js already implements. Same key formula as its zoneKey(), on purpose: two
// different normalisations of a hub name would silently disagree about which trucks are a hub's.
function hubZoneKey(z){
    return String(z || "").toUpperCase().replace(/[^0-9A-Z]/g, "");
}

// ---------------------------------------------------------------------------------------------
// MANUAL COUNTS CARRY A DATE, AND EXPIRE (client, 2026-10-16: "similar to punching date, Available
// on is one date, Availability marked on & by whom also should be stored").
// A manual count states ONE DAY's trucks - exactly what a portal punch does - but unlike a punch
// it sat in the document for ever, so every future plan of the warehouse kept being told the same
// trucks were standing there. Node AND the Python engine now IGNORE counts whose `available_on` is
// not today (IST) and fall back to the mode's normal supply. This screen therefore has to resolve
// the date the SAME way they do, or it would show counts as live that planning has already thrown
// away (or vice versa) - the one failure this feature exists to prevent.
//
// Today in IST, not in the browser's zone: `available_on` is an IST calendar date, and a user
// sitting in another timezone (or a machine with a wrong TZ) must still see the day planning uses.
// Same expression as lmConsigneesController.js / dbcalls.manual_availability_for_mode.
function istToday(){
    return moment.parseZone().utcOffset("+05:30").format("YYYY-MM-DD");
}
// The EFFECTIVE date of a mode's counts - a verbatim mirror of the server's fallback chain:
//   explicit modes.<MODE>.available_on  ->  modes.<MODE>.updated_at  ->  document created_date.
// A LEGACY document (saved before the date existed) has no `available_on` at all, so its SAVE DATE
// stands in: those counts were meant for the day they were entered, and left dateless they would
// keep reporting the same trucks for ever. Returns "" when nothing at all is known - and "" is NOT
// stale, because the server's test is `if (availableOn && availableOn !== todayIst)`: a date that
// cannot be read is never grounds for telling the user their counts are being ignored.
// ⚠ parseZone(), not moment(): `updated_at` / `created_date` are written by the server as
// moment.parseZone(new Date()).utcOffset("+05:30")._d, i.e. a Date whose UTC fields carry the IST
// WALL CLOCK (a 16:54 IST save stores 16:54Z). parseZone reads that wall clock back as-is, which
// is the IST calendar date we want; moment() would convert it a second time and could slide the
// date back a day for anything saved before 05:30 IST.
function manualEffectiveAvailableOn(storedMode, doc){
    var m = storedMode || {};
    var explicit = (m.available_on === undefined || m.available_on === null) ? "" : String(m.available_on).trim();
    if(explicit !== "") return explicit;
    if(m.updated_at) return moment.parseZone(m.updated_at).format("YYYY-MM-DD");
    if(doc && doc.created_date) return moment.parseZone(doc.created_date).format("YYYY-MM-DD");
    return "";
}
// "Marked on" - the provenance instant, NOT a calendar date.
// ⚠ moment(), NOT moment.parseZone(): `marked_at` is written by the server as a plain `new Date()`,
// i.e. a TRUE UTC instant serialised with a trailing Z - unlike `updated_at` / `created_date`
// above, which carry the IST wall clock in their UTC fields. moment() converts a true instant into
// the browser's own zone (IST for every user of this screen), which is what a reader expects.
// parseZone() would preserve the +00:00 offset and display it 5h30m EARLY, and adding 5:30 by hand
// on top of moment() is the double-shift bug this project has just fixed elsewhere - do neither.
function formatMarkedAt(value){
    if(value === undefined || value === null || value === "") return "";
    var m = moment(value);
    return m.isValid() ? m.format("DD-MMM-YYYY HH:mm") : "";
}
// The date to PRE-FILL the "Available on" input with for a mode.
// Today by default (the overwhelmingly common intent: "these are the trucks standing there now").
// A stored date is honoured only when it is today or LATER - a user who deliberately dated counts
// for tomorrow must not have that quietly pulled back to today by simply opening the screen, while
// a STALE date must never be re-offered: re-saving it would store counts planning ignores, which
// looks exactly like a save that did nothing.
function defaultAvailableOnInput(effectiveOn){
    var today = istToday();
    if(effectiveOn && effectiveOn >= today) return effectiveOn;   // ISO dates compare lexically
    return today;
}

// Mirrors the SERVER's resolution rule for /getmanualvehicleavailability, and must stay identical
// to it: use modes[KEY] when the warehouse has saved per-mode data, otherwise fall back to the
// LEGACY warehouse-wide `use_manual_vehicle_availability` + `availabilitydata` pair. So a
// warehouse that has never saved per-mode data opens with its EXISTING tick and its EXISTING
// counts under every mode - nobody loses their configuration on deploy.
function resolveManualModes(doc){
    var legacyUse = !!(doc && doc.use_manual_vehicle_availability === true);
    var legacyData = (doc && Array.isArray(doc.availabilitydata)) ? doc.availabilitydata : [];
    var modes = {};
    MANUAL_MODES.forEach(function(m){
        var stored = (doc && doc.modes) ? doc.modes[m.key] : null;
        // Date + provenance are resolved for EVERY mode off the SAME chain the server uses, even
        // for a mode falling back to the legacy pair (where the server sees modes.<MODE> as {} and
        // lands on the document's created_date) - so the screen's verdict on "are these counts
        // live today?" can never disagree with the engine's.
        var effective_on = manualEffectiveAvailableOn(stored, doc);
        var marked_at = stored && stored.marked_at ? stored.marked_at : "";
        var marked_by = stored && stored.marked_by ? String(stored.marked_by) : "";
        if(stored){
            modes[m.key] = {
                use: stored.use === true,
                data: Array.isArray(stored.availabilitydata) ? stored.availabilitydata : [],
                effective_on: effective_on,
                marked_at: marked_at,
                marked_by: marked_by,
            };
        } else if (m.hub || m.key === "REGULAR") {
            // The legacy warehouse-wide pair is inherited by REGULAR and HUB ONLY, because those
            // are the only stages that ever read truck availability. Dedicated and Courier
            // FABRICATE their supply and have only just been given the option, so a warehouse that
            // ticked manual years ago must not open with Dedicated and Courier showing as ticked
            // and carrying Regular's counts - the screen would then be claiming a configuration
            // that Node and the engine both resolve as OFF (lmConsigneesController
            // MANUAL_LEGACY_FALLBACK_MODES / dbcalls.manual_availability_for_mode). All three
            // definitions have to agree or the screen lies about what a run will do.
            // A legacy document carries NO provenance - it predates the fields - so "Marked on /
            // by" is simply blank there rather than invented from the save date, which says when
            // the document was written, not who asserted the trucks. The DATE is still resolved
            // (created_date), because the server expires these counts on exactly that value.
            modes[m.key] = {
                use: legacyUse, data: legacyData,
                effective_on: effective_on, marked_at: marked_at, marked_by: marked_by,
            };
        } else {
            modes[m.key] = {
                use: false, data: [],
                effective_on: effective_on, marked_at: marked_at, marked_by: marked_by,
            };
        }
    });
    return modes;
}

// Width for one "<zone> / <vehicle type>" cell, shared by BOTH availability grids so the system
// view and the manual view line up. Scales down as zones x vehicle types grows, and is clamped so
// a 2-column warehouse does not get absurdly wide columns nor a 12-column one unreadable ones.
function zoneChildColumnWidth(childCount){
    // A count cell holds at most 2-3 digits, so it never needs to be wide; the header
    // ("32 FT VEHICLE") is what sets the floor. Fixed rather than proportional: these columns
    // are marked suppressSizeToFit, so sizeColumnsToFit() can no longer stretch them to fill
    // the grid - which is exactly what made them absurdly wide with only a handful of columns.
    if(!childCount || childCount < 1) return 130;
    return childCount > 8 ? 110 : 130;
}

// Light green wash on any count cell that actually holds trucks. Most of this grid is zeros - a
// warehouse has trucks in a handful of (zone, vehicle type) cells and none in the rest - so the
// few populated cells are what a reader is looking for and they are easy to miss in a field of 0s.
// Returns null rather than undefined when there is nothing to highlight: AG Grid needs an explicit
// null to CLEAR a previously applied style when the cell is re-rendered (e.g. after an edit takes
// a count back down to 0), otherwise the green stays behind on a now-zero cell.
function availabilityCellStyle(params){
    var n = parseInt(params.value, 10);
    if(!isNaN(n) && n > 0){
        return { backgroundColor: "#e3f6e3" };
    }
    return null;
}

// ---------------------------------------------------------------------------------------------
// Manual Availability vs the Transporters master. A count is only accepted where the master maps
// the transporter to that (zone, vehicle type) at this warehouse, in any planning tab. Same rule
// as isManualCellAllowed in lmConsigneesController.js, which also refuses the save - this is the
// on-screen half. `mapping` = { NAME: { zones: { ZONEKEY: { "<vehicle type>": true } },
// any: { "<vehicle type>": true } } } from /getManualAvailabilityMapping; null = not loaded, in
// which case nothing is greyed out and the server check still applies.
function manualTransporterKey(name){
    return String(name === undefined || name === null ? "" : name).trim().toUpperCase().replace(/\s+/g, " ");
}
function manualZoneKey(zone){
    return String(zone || "").toUpperCase().replace(/\s+/g, "");
}
function isManualCellAllowed(mapping, transporterName, zone, vehicleType){
    if(!mapping) return true;
    var t = mapping[manualTransporterKey(transporterName)];
    if(!t) return false;
    var veh = String(vehicleType || "").trim();
    var z = String(zone || "").trim();
    if(z === "" || z.toUpperCase() === ZONE_NOT_SET_LABEL) return !!(t.any && t.any[veh]);
    var zv = t.zones ? t.zones[manualZoneKey(z)] : null;
    return !!(zv && zv[veh]);
}
function isManualTransporterKnown(mapping, transporterName){
    if(!mapping) return true;
    return !!mapping[manualTransporterKey(transporterName)];
}

// Right-align the value columns AND their headers, so a count sits directly under its header
// instead of drifting to the other end of a wide column.
const ZONE_VALUE_COL = {
    type: "numericColumn",
    cellClass: "ag-right-aligned-cell",
    headerClass: "ag-right-aligned-header",
    resizable: true,
    suppressSizeToFit: true,
    cellStyle: availabilityCellStyle,
};

export default class LmTruckAvailability extends Component {
  static contextType = LoadingPortContext;

  constructor(props, context) {
    super(props, context);
    this._lastLoadingPortCode = context ? context.loading_port_code : null;
      this.state = {
        modules : AllModules,
        defaultColDef: {
            sortable: true,
            filter: true,
            editable: true,
        },
        eventAction: null,
        show: false,
        frameworkComponents : {
          consignmentforceclose:Consignmentforceclose,
          consignmentActions:ConsignmentActions,
          UpdateButton:UpdateButton,
          MarkDeliver : MarkDeliver,
          commentActions : CommentActions,
          Showlmvalue:Showlmvalue
        },
        modified_by:"",
        basicTitle:'',
        reasonforceclose:"",
        bulkslide:"",
        file:"",
        uploadFile:"",
        basicType:"default",
        loadshow:'show-n',
        forceCloseRowNode : "",
        forceclosedata:"",
        csvcontent:"",
        sliderForceCloseTranslate:"",
        overly:'',
        rowData:[],
        // Punched trucks planning will NOT use for this warehouse, with the reason (Node
        // with_ignored) - Truck Availability tab / Truck Details tab respectively.
        feedIgnored:[],
        truckIgnored:[],
        bulkslide:"",
        bulkslide1:"",
        showDiv:"",
        uploadDivWidth:"",
        mapinfo:"",
        dealer:"",
        sliderCommentTranslate:"",
        commentsRowData:"",
        consignment_code:"",
        sliderRouteTranslate:"",
        maptruckno:"",
        routeTruck:	"",
        rownode:"",
        googelRoutes:"",
        file:"",
        rowSelection:'multiple',
        sliderForceCloseTranslate:"",
        maptruckno:"",
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
            statusBar: {
        statusPanels: [
          {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left"
          },
          {
          statusPanel: "agTotalRowCountComponent",
          align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
        ]
            },
        paginationPageSize:200,
        geofencelist:[],
        geoFenceData:"",
        sideBar: {
          toolPanels: [
            {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel"
            },
            {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel"
            }
          ]
        },
        animateRows: true,
        dept_code:"",
        pagetitle:"",
        markDeliverRowNode : "",
        markDeliverData:"",
        sliderMarkDeliverTranslate:"",
        csvData:0,
        overly:"show-n",
        loadshow:"show-n",
        trnsportersList : [],
        statesList : [],
        vehicleList: [],
        showCalendar : "show-m",
        showGridData : "show-m",
        showGridData1 : "show-n",
        transdata:[],
        transactionId : "",
        partial: "activet",
        complete: "",
        partialData: "",
        completeData: "show-n",
        truckData: [],
        lmtransporters: [],
        manualMapping: null,
        selectedTransporter : {},
        lmvehicletypes: [],
        lmhubvehicles: [],
        lmzones: [],
        pageType: 1,
        comp_code : "",
        lpNames : [],
        loading_port_code : "",
        data_type:1,
        // The Hub tab is data_type 1 + this flag (Regular and Hub are not distinguishable by
        // data_type alone). Sent as `is_hub` wherever Node resolves a mode from the pair.
        is_hub:false,
        // "Manual is on" for the mode of the tab on screen (= state.manual_mode). Kept as its own
        // field because the loaders decide with it before the per-mode data is in state.
        manual_vehicle_availability:false,
        // Per-mode manual state: { REGULAR: { use, rows, ... }, HUB: {...}, DEDICATED: {...},
        // COURIER: {...} }. `rows` is already normalised for that mode's columns. The date block:
        //   effective_on        - the date PLANNING resolves these counts to (server's chain);
        //                         compared against today to decide whether they are being used.
        //   available_on_input  - what the "Available on" picker holds, i.e. the date the NEXT
        //                         save will stamp. Kept separate from effective_on so an unsaved
        //                         edit can never be mistaken for the stored (and enforced) value.
        //   marked_at/marked_by - provenance written by the server on the last save.
        manual_modes: (function(){
            var init = {};
            MANUAL_MODE_KEYS.forEach(function(k){
                init[k] = { use:false, rows:[], effective_on:"", available_on_input:istToday(),
                            marked_at:"", marked_by:"" };
            });
            return init;
        })(),
        manual_mode: "REGULAR",          // the TOP TAB, which is the mode (see MANUAL_MODES)
        // Vehicle masters per mode, so the Dedicated / Courier / Hub grids show THEIR vehicle
        // types - a mode's master is not the one the previously open tab happened to fetch.
        lmvehicletypesByMode: {},
        lmtransportersByMode: {},
        // zoneKey(hub name) -> hub name, from /masters/getHubMasterData. Decides which feed
        // trucks are a hub's (zone == hub name) and the Hub tab's column groups.
        hubNames: {},
        // Forces the "system" grid to fully unmount/remount once real columns
        // are ready (see createColumns) - matches what a tab switch does,
        // which is the one thing that reliably made the missing columns show
        // up. Bumped, not just toggled, so it changes every time regardless
        // of its previous value.
        gridInstanceKey: 0
    }
    // Per-tab load bookkeeping (1 = Truck Availability, 2 = Truck Details):
    //  _loadSeq     - latest load started for each tab; an older response that lands later is
    //                 dropped, so it can neither overwrite newer data nor hide the overlay early.
    //  _loadedFor   - "<warehouse>|<data_type>" each tab last finished loading for. Switching
    //                 between the two tabs reuses it instead of refetching everything (incl. the
    //                 slow external truck feed); _invalidateLoads() forces a refetch after a change.
    //  _inflight    - loads still running; the overlay is hidden only when it reaches 0.
    this._loadSeq = { 1: 0, 2: 0 };
    this._loadedFor = {};
    this._inflight = 0;
    this.onLoadShowData = this.onLoadShowData.bind(this);
    this.createColumns = this.createColumns.bind(this);
    this.createRows = this.createRows.bind(this);
    this.changeFileHandler = this.changeFileHandler.bind(this);
    this.uploadBulkFormHandler = this.uploadBulkFormHandler.bind(this);
    this.uploadSingleFormHandler = this.uploadSingleFormHandler.bind(this);
  }

componentDidMount(){
    loadDateTimeScript();
    this.pageAccess(1);
    // MASTER SCREEN ONLY (client, 2026-10-14). The route still takes an :eventname segment so old
    // links and the menu entry ("/lmtruckavailability/default") keep working, but a transaction id
    // in it is ignored: SOB is no longer run by walking Truck Availability -> Assign Transporters
    // -> Load Share. The SOB panel on the plan shows today's trucks and runs SOB in one place.
}
async pageAccess(pageType){
    this.setState({
        loadshow:'show-m',
        overly:'show-m',
    })
    var currentUrl = "/lmtruckavailability/default";
    var resolved = await resolvePageAccess(currentUrl, this.context);
    if (!resolved) {
        // No access (already alerted+redirected), empty port list, or a logged request error.
        this.setState({ loadshow: 'show-n', overly: 'show-n' });
        return;
    }
    this._lastLoadingPortCode = resolved.loading_port_code;
    this.setState({
        pageAccess: resolved.pageAccess,
        loading_port_code: resolved.loading_port_code,
        comp_code: resolved.comp_code,
        lpNames: resolved.lpNames,
    });
    // The overlay is left up: the loader below owns it (_beginLoad/_endLoad), and hiding it here
    // briefly revealed a half-built grid between access resolution and the data fetch.
    if (pageType == 1) {
        await this.onLoadShowData();
    } else {
        await this.loadPageData();
    }
}
_loadKey(){
    // The MODE, not just the data_type: Regular and Hub are both data_type 1, so without it the
    // Hub tab would reuse Regular's finished load and never fetch its own.
    return String(this.state.loading_port_code) + "|" + String(this.state.manual_mode);
}
_invalidateLoads(){
    this._loadedFor = {};
}
_beginLoad(tab){
    this._loadSeq[tab] = this._loadSeq[tab] + 1;
    this._inflight = this._inflight + 1;
    this.setState({ overly:"show-m", loadshow:"show-m" });
    return this._loadSeq[tab];
}
// Returns true when this load is still the latest for its tab (its results may be applied).
_endLoad(tab, seq){
    this._inflight = Math.max(0, this._inflight - 1);
    var current = seq === this._loadSeq[tab];
    if(current){ this._loadedFor[tab] = this._loadKey(); }
    if(this._inflight === 0){ this.setState({ overly:"show-n", loadshow:"show-n" }); }
    return current;
}
onLoadShowData = async(transactionId) =>{
    var seq = this._beginLoad(1);
    try {
        //var truckUrl = "/lmconsignees/getLmTruckAvailability";
        // Data From Autometrics
        var truckUrl = "/lmconsignees/getPRTTruckAvailableData";
        //var truckUrl = "/lmconsignees/getLMTruckAvailableData";
        // if(transactionId !=undefined && transactionId !='')
        // {
        //     var truckUrl = "/lmconsignees/getUpdatedLmTruckAvailability";
        // }
        console.log(truckUrl,"truckUrl")
        var loading_port_code = this.state.loading_port_code;
        var sdate = moment.parseZone().format('YYYY-MM-DD');
        var edate = moment.parseZone().format('YYYY-MM-DD');
        var params = {
            transactionId : transactionId,
            loading_port_code : loading_port_code,
            data_type : this.state.data_type,
            startDate : sdate,
            endDate : edate,
            request_type : 1
        }
        // The MANUAL grid's columns come from the vehicle master (configuredVehicleTypes) and its Zone
        // dropdown from the zone master - both were only ever fetched by loadPageData(), i.e. the
        // "Truck Details" tab. So a warehouse with "Use Manual Availability" already ticked opened
        // with nothing but the Transporter column, and the vehicle-type columns appeared only after
        // visiting the other tab and coming back. Load them here too.
        // Clear first: the grid's COLUMNS are derived from transdata, so if this fetch fails or
        // returns nothing the previous warehouse's columns stayed on screen. MSILK is absent from the
        // backend's warehouseMapping and 400s, which is why it rendered another warehouse's vehicle
        // types (incl. hub) with mismatched counts.
        await this.setState({ transdata: [] })
        // The live truck feed comes from an EXTERNAL system and is the slow part of this screen
        // (seconds normally, ~60 s at times). With "Use Manual Availability" on, the system grid it
        // feeds is not shown at all, so read the warehouse's flag first (with the masters - both
        // fast) and call the feed only when manual is off. Toggling manual off reloads and fetches it.
        // ⚠ PER-MODE: the tick belongs to the TAB (= mode), so only this tab's own tick suppresses
        // the feed. Ticking Hub leaves the Regular tab fetching and showing the feed exactly as
        // before. The Hub tab shares the Regular feed (hub trucks are reported with zone = hub
        // name - see hubZoneKey), so it is fetched for the mode's data_type either way.
        var feed = [];
        var feedIgnored = [];
        var manualOn = false;
        await Promise.all([
            this.loadMasterLists(),
            redirectURL.post("/lmconsignees/getmanualvehicleavailability", { plant_code: loading_port_code })
                .then((r) => {
                    var doc = (Array.isArray(r.data) && r.data.length > 0) ? r.data[0] : null;
                    var modes = resolveManualModes(doc);
                    manualOn = modes[this.state.manual_mode].use === true;
                })
                .catch((e) => { console.log(e); })
        ]);
        if(!manualOn && seq === this._loadSeq[1]){
            // with_ignored: Node returns { rows, ignored } - the trucks of the plant that planning
            // will NOT use (another warehouse's category), so the screen can say why they are
            // missing. An older Node ignores the flag and returns the plain array.
            await redirectURL.post(truckUrl, Object.assign({}, params, { with_ignored: 1 })).then((response)=>{
                var d = response.data;
                if (Array.isArray(d)) { feed = d; }
                else if (d && Array.isArray(d.rows)) {
                    feed = d.rows;
                    feedIgnored = Array.isArray(d.ignored) ? d.ignored : [];
                }
            }).catch((e)=>{
                console.log(e);
            });
        }
        if(seq !== this._loadSeq[1]){ this._endLoad(1, seq); return; }   // superseded by a newer load
        await this.setState({ transdata: feed, feedIgnored: feedIgnored });
        await this.createColumns();
        await this.createRows();
        await this.getmanualvehicleavailability();
        // The overlay is hidden only once every in-flight load has finished (see _endLoad), after
        // every fetch that decides WHICH grid should render (system vs. manual).
        this._endLoad(1, seq);
    } catch(e) {
        // Never leave the overlay up because one step failed.
        console.log(e);
        this._endLoad(1, seq);
    }
}
// Vehicle types + zones for THIS warehouse. Awaited by both entry points (onLoadShowData for the
// Truck Availability tab, loadPageData for Truck Details), because the manual grid's columns and
// the Add Truck form are both built from them - fetching them on only one tab is what left the
// manual grid showing a single column until the user switched tabs.
async loadMasterLists(){
    var params = {
        loading_port_code : this.state.loading_port_code,
        data_type : this.state.data_type,
    }
    // Independent - fetched together.
    var vehP = redirectURL.post('/lmconsignees/getLmVehicleCapacity', params)
        .then((vehResp) => this.setState({ lmvehicletypes: Array.isArray(vehResp.data) ? vehResp.data : [] }))
        .catch((e) => { console.log("getLmVehicleCapacity failed", e); });
    var zoneP = redirectURL.post('/lmconsignees/getLmSobZones', params)
        .then((zoneResp) => this.setState({ lmzones: Array.isArray(zoneResp.data) ? zoneResp.data : [] }))
        .catch((e) => { console.log("getLmSobZones failed", e); });
    // HUB vehicle rows (zone = hub name) - the manual grid's hub groups (client, 2026-10-09).
    // Hub vehicles are a REGULAR (data_type 1) master, whatever tab is open.
    var hubP = redirectURL.post('/lmconsignees/getLmVehicleCapacity',
            { loading_port_code: this.state.loading_port_code, data_type: 1, hub_vehicle: 1 })
        .then((r) => this.setState({ lmhubvehicles: Array.isArray(r.data) ? r.data : [] }))
        .catch((e) => { console.log("getLmVehicleCapacity (hub) failed", e); });
    // The warehouse's HUBS. A hub truck is one whose ZONE is a hub name (the feed reports the
    // plain size, never '32 FT HUB Vehicle'), so this list is what splits the one feed into the
    // Hub tab and the Regular tab - the same split the engine makes and sobRunPanel.js shows.
    // A failure leaves it empty: nothing is then treated as a hub truck, which is the safe
    // direction (trucks stay visible on Regular) and never invents a hub.
    var hubNameP = redirectURL.post('/masters/getHubMasterData',
            { loading_port_code: this.state.loading_port_code, is_active: 1 })
        .then((r) => {
            var names = {};
            ((r.data && r.data.hubData) || []).forEach(function(h){
                var n = (h && h.hub_name) ? String(h.hub_name).trim().toUpperCase() : "";
                var k = hubZoneKey(n);
                if(k) names[k] = n;
            });
            this.setState({ hubNames: names });
        })
        .catch((e) => { console.log("getHubMasterData failed", e); this.setState({ hubNames: {} }); });
    // Per-mode masters. The four Manual Availability modes are INDEPENDENT of the planning-type
    // tab on screen, so each one's grid has to be built from its OWN vehicle master and its OWN
    // transporter list - reusing the open tab's master would show a Dedicated grid full of
    // Regular vehicle types, and (worse) would leave Dedicated/Courier with no rows at all,
    // because getLmUniqueTransporters was only ever fetched on the Truck Details tab. Small,
    // fast master reads, fired in parallel with the three above.
    var MODE_DATA_TYPE = { REGULAR: 1, COURIER: 2, DEDICATED: 3 };
    var vehByMode = {};
    var tptByMode = {};
    var modeP = [];
    Object.keys(MODE_DATA_TYPE).forEach((mode) => {
        var p = { loading_port_code: this.state.loading_port_code, data_type: MODE_DATA_TYPE[mode] };
        modeP.push(redirectURL.post('/lmconsignees/getLmVehicleCapacity', p)
            .then((r) => { vehByMode[mode] = Array.isArray(r.data) ? r.data : []; })
            .catch((e) => { console.log("getLmVehicleCapacity (" + mode + ") failed", e); }));
        modeP.push(redirectURL.post('/lmconsignees/getLmUniqueTransporters', p)
            .then((r) => {
                var names = [];
                (r.data || []).forEach(function(lt){ if(lt && lt.transporter_name) names.push(lt.transporter_name); });
                tptByMode[mode] = names;
            })
            .catch((e) => { console.log("getLmUniqueTransporters (" + mode + ") failed", e); }));
    });
    await Promise.all([vehP, zoneP, hubP, hubNameP].concat(modeP));
    // HUB has no planning type of its own: a hub transporter is mapped on the Transporters
    // master's Hub tab, which is not one of the three data_types, so offer the union of all
    // known transporters there and let the Transporters-master check grey out the rest.
    var union = [];
    Object.keys(tptByMode).forEach(function(m){
        tptByMode[m].forEach(function(n){ if(union.indexOf(n) === -1) union.push(n); });
    });
    tptByMode["HUB"] = union;
    this.setState({ lmvehicletypesByMode: vehByMode, lmtransportersByMode: tptByMode });
}

async loadPageData(){
    var seq = this._beginLoad(2);
    try {
        var loading_port_code = this.state.loading_port_code;
        var params = {
            loading_port_code : loading_port_code,
            data_type : this.state.data_type,
        }
        var tptP = redirectURL.post('/lmconsignees/getLmUniqueTransporters',params)
        .then((response) => {
            var ltms = [];
            (response.data || []).map(function(lt){
                ltms.push({
                    "label" : lt.transporter_name,
                    "value" : lt.transporter_code,
                })
            });
            if(seq === this._loadSeq[2]){ this.setState({ lmtransporters:ltms }); }
        })
        .catch(function(error){
            console.log(error)
        });
        // ⚠ `is_hub` is NOT optional. Regular and Hub are BOTH data_type 1, and Node resolves
        // which mode's MANUAL counts to fold into this response from (data_type + is_hub) - with
        // no flag it resolves to REGULAR, so the Hub tab would list Regular's manual trucks and a
        // Hub manual entry would appear to do nothing. Same contract sobRunPanel.js codes against.
        var truckP = redirectURL.post('/lmconsignees/getLmTrucksDetails',
                Object.assign({}, params, { is_hub: this.state.is_hub ? 1 : 0, with_ignored: 1 }))
        .then((response) => {
            var d = response.data;
            var trucks = Array.isArray(d) ? d : ((d && Array.isArray(d.trucks)) ? d.trucks : []);
            var ignored = (d && !Array.isArray(d) && Array.isArray(d.ignored)) ? d.ignored : [];
            if(seq === this._loadSeq[2]){ this.setState({ truckData: trucks, truckIgnored: ignored }); }
        })
        .catch(function(error){
            console.log(error)
        });
        // The manual flag decides whether this tab exists at all - a warehouse / planning-type
        // change can land here (still on Truck Details) for a warehouse that uses manual counts.
        // Read it for the mode of the TAB on screen: Truck Details lists that tab's trucks, so a
        // Hub-only tick must not hide the Regular tab's.
        var manualOn = false;
        var flagP = redirectURL.post("/lmconsignees/getmanualvehicleavailability", { plant_code: loading_port_code })
            .then((r) => {
                var doc = (Array.isArray(r.data) && r.data.length > 0) ? r.data[0] : null;
                manualOn = resolveManualModes(doc)[this.state.manual_mode].use === true;
            })
            .catch((e) => { console.log(e); });
        await Promise.all([tptP, truckP, flagP, this.loadMasterLists()]);
        if(seq === this._loadSeq[2] && manualOn){
            this._endLoad(2, seq);
            await this.setState({ manual_vehicle_availability: true });
            this.onClickTab("partial");
            return;
        }
        this._endLoad(2, seq);
    } catch(e) {
        // Never leave the overlay up because one step failed.
        console.log(e);
        this._endLoad(2, seq);
    }
}
// The warehouse's CONFIGURED non-hub vehicle types, deduped and in a stable size order.
// Driven by the vehicle master (lmvehiclecapacity via getLmVehicleCapacity) instead of a
// hardcoded list, so the Manual Availability grid shows exactly the types the warehouse has:
// GUR/MSILG was rendering phantom "20 FT Small" / "14 FT" / "7 FT" columns it does not
// configure, while a newly configured type would never have appeared at all.
// HUB types are deliberately excluded for now (client, 2026-08-26); getLmVehicleCapacity
// already defaults hub_vehicle to 0, the name test is belt-and-braces.
// Zones configured for this warehouse, taken from the SAME source the planning engine uses
// (lmsobzones via getLmSobZones), so the Manual Availability dropdown can never offer a zone the
// engine would not recognise. Blank is offered too and means "not earmarked / any zone".
configuredZones(){
    var rows = this.state.lmzones || [];
    var seen = {};
    var zones = [];
    rows.forEach(function(r){
        var z = (r && r.zone) ? String(r.zone).trim() : "";
        if(z === "" || seen[z]) return;
        seen[z] = true;
        zones.push(z);
    });
    zones.sort();
    return zones;
}

// HUB groups for the Manual Availability grid: [{ hub, types }] - each hub with the hub vehicle
// types configured for it (lmvehiclecapacity hub rows, zone = bare hub name, e.g. CHENNAI). Hub SOB
// reads a count in "<HUB>||<hub vehicle>" as trucks earmarked for that hub, exactly like a live-feed
// truck punched for the hub. A hub name that is also a regular zone is left to the zone group.
configuredHubGroups(){
    var regular = {};
    this.configuredZones().forEach(function(z){ regular[manualZoneKey(z)] = true; });
    var byHub = {};
    var order = [];
    (this.state.lmhubvehicles || []).forEach(function(r){
        var hub = (r && r.zone) ? String(r.zone).trim().toUpperCase() : "";
        var vt = (r && r.vehicle_cap) ? String(r.vehicle_cap).trim() : "";
        if(hub === "" || hub === "ALL" || vt === "" || regular[manualZoneKey(hub)]) return;
        if(!byHub[hub]){ byHub[hub] = []; order.push(hub); }
        if(byHub[hub].indexOf(vt) === -1) byHub[hub].push(vt);
    });
    order.sort();
    return order.map(function(h){ return { hub: h, types: byHub[h].sort().reverse() }; });
}

// `mode` (optional) = one of the Manual Availability modes; its own vehicle master is used, so a
// Dedicated grid shows Dedicated types whatever planning-type tab happens to be open. Omitted
// (system grid, Add Truck form) = the master of the tab on screen, exactly as before.
configuredVehicleTypes(mode){
    var VEHICLE_ORDER = ["32 FT Vehicle", "20 FT Vehicle", "20 FT Small",
                         "14 FT Vehicle", "7 FT Vehicle"];
    var byMode = this.state.lmvehicletypesByMode || {};
    var rows = (mode && byMode[mode]) ? byMode[mode] : (this.state.lmvehicletypes || []);
    var seen = {};
    var types = [];
    rows.forEach(function(r){
        var v = (r && r.vehicle_cap) ? String(r.vehicle_cap).trim() : "";
        if(v === "" || v.toUpperCase().indexOf("HUB") >= 0) return;
        if(seen[v]) return;
        seen[v] = true;
        types.push(v);
    });
    types.sort(function(a, b){
        var ia = VEHICLE_ORDER.indexOf(a), ib = VEHICLE_ORDER.indexOf(b);
        if(ia === -1 && ib === -1) return a < b ? -1 : (a > b ? 1 : 0);
        if(ia === -1) return 1;
        if(ib === -1) return -1;
        return ia - ib;
    });
    return types;
}
// Column groups of ONE mode's Manual Availability grid: [{ header, zone, types }]. One builder for
// all four modes - the grid rendering, the Transporters-master check, the blank-row seeding and the
// save all walk this, so a mode can never render one set of cells and save another.
//  HUB  -> one group per hub, its hub vehicle types (cell key "<HUB>||<hub vehicle>", which is what
//          hub SOB reads). No ZONE NOT SET group: a hub truck is by definition earmarked.
//  else -> the warehouse's zones + ZONE NOT SET, x that MODE's vehicle types.
// The cell key stays "<zone>||<vehicle type>" in every mode - the Node reader and the Python
// engine both parse that format.
manualGroupsForMode(mode){
    if(mode === "HUB"){
        return this.configuredHubGroups().map(function(g){
            return { header: "HUB · " + g.hub, zone: g.hub, types: g.types };
        });
    }
    var types = this.configuredVehicleTypes(mode);
    return this.configuredZones().concat([ZONE_NOT_SET_LABEL]).map(function(z){
        return {
            // "ZONE NOT SET" carries trucks the LSP has not earmarked, and is where legacy
            // (pre-zone) counts land. The engine does NOT consider them for SOB any more
            // (defines.ZONE_UNSET_TRUCK_USABLE = False, client 2026-09-29), so the group is kept
            // - and kept EDITABLE, so an existing count can be seen and zeroed - but its header
            // says plainly that anything left there is ignored.
            header: z === ZONE_NOT_SET_LABEL ? ZONE_NOT_SET_LABEL + " (not used in SOB)" : z,
            zone: z,
            types: types,
        };
    });
}
// Every "<zone>||<vehicle type>" key this mode renders. Also the save-time whitelist: see
// saveManualVehicleAvailabilty.
manualKeysForMode(mode){
    var keys = [];
    this.manualGroupsForMode(mode).forEach(function(g){
        g.types.forEach(function(vt){ keys.push(g.zone + ZONE_COL_SEP + vt); });
    });
    return keys;
}
// Saved documents -> grid rows for ONE mode. Every transporter gets a row even if it was never
// saved (otherwise a mode nobody has configured yet opens blank and cannot be used at all - the
// whole point of giving Dedicated/Courier their own grids is that they have no live feed), then
// the stored counts are overlaid.
normaliseManualRows(mode, saved){
    var groups = this.manualGroupsForMode(mode);
    // The "<transporter>-<type>" whitelist rule, per mode: a legacy plain "<vehicle type>" key
    // (saved before zones existed) is only folded into a zone key for a type THIS mode renders;
    // a type the mode does not know keeps its own key and is simply not shown.
    var knownTypes = {};
    groups.forEach(function(g){ g.types.forEach(function(vt){ knownTypes[vt] = true; }); });
    // Legacy keys carry no zone, so they mean "not earmarked" -> ZONE NOT SET. HUB has no such
    // group (a hub truck is always earmarked), so there a legacy plain key has nowhere to land
    // and is left alone rather than invented into some hub.
    var legacyFallbackZone = (mode === "HUB") ? null : ZONE_NOT_SET_LABEL;
    var keys = this.manualKeysForMode(mode);

    function blankRow(name){
        var row = { transporter_name: name };
        keys.forEach(function(k){ row[k] = 0; });
        return row;
    }

    var names = [];
    var byModeTpts = (this.state.lmtransportersByMode || {})[mode];
    if(byModeTpts && byModeTpts.length > 0){
        byModeTpts.forEach(function(n){ if(names.indexOf(n) === -1) names.push(n); });
    } else {
        (this.state.lmtransporters || []).forEach(function(t){
            if(t && t.label && names.indexOf(t.label) === -1) names.push(t.label);
        });
    }
    (saved || []).forEach(function(item){
        if(item && item.transporter_name && names.indexOf(item.transporter_name) === -1){
            names.push(item.transporter_name);
        }
    });
    if(names.length === 0){
        (this.state.rowData || []).forEach(function(r){
            if(r && r.transporter_name && names.indexOf(r.transporter_name) === -1) names.push(r.transporter_name);
        });
    }
    var byName = {};
    names.forEach(function(n){ byName[n] = blankRow(n); });

    (saved || []).forEach(function(item){
        if(!item || !item.transporter_name) return;
        var row = byName[item.transporter_name] || blankRow(item.transporter_name);
        // A row saved before zones existed may carry its own single "zone" value; honour it.
        var legacyZone = (item.zone === undefined || item.zone === null || String(item.zone).trim() === "")
            ? legacyFallbackZone : String(item.zone).trim();
        Object.keys(item).forEach(function(key){
            if(key === "transporter_name" || key === "zone") return;
            var val = parseInt(item[key], 10);
            if(isNaN(val)) val = 0;
            if(key.indexOf(ZONE_COL_SEP) >= 0){
                row[key] = val;                                  // already "<zone>||<type>"
            } else if(legacyZone && knownTypes[key]){
                row[legacyZone + ZONE_COL_SEP + key] = val;      // legacy plain "<type>"
            }
        });
        byName[item.transporter_name] = row;
    });
    return names.map(function(n){ return byName[n]; });
}

// The live-feed rows belonging to the TAB on screen. ONE feed carries hub and regular trucks
// together - a hub truck is reported by SIZE with its zone set to the HUB NAME - so the Hub tab
// is the hub-zoned rows and every other tab is the rest. Same split as the engine
// (sob_lsp_hub.split_hub_trucks) and sobRunPanel.js, via the shared hubZoneKey formula.
// No hub master (or a failed fetch) = no hub zones = nothing is hidden from the Regular tab.
// The column group a feed row belongs to. On the Hub tab the HUB MASTER's spelling wins, so a
// feed zone of 'Chennai' and a master hub 'CHENNAI' are ONE group and not two half-filled ones.
tabZoneLabel(zone){
    var hubs = this.state.hubNames || {};
    var k = hubZoneKey(zone);
    if(this.state.is_hub && hubs[k] !== undefined) return hubs[k];
    return String(zone === undefined || zone === null ? "" : zone);
}
feedRowsForTab(){
    var hubs = this.state.hubNames || {};
    var wantHub = !!this.state.is_hub;
    return (this.state.transdata || []).filter(function(r){
        return (hubs[hubZoneKey(r ? r.zone : "")] !== undefined) === wantHub;
    });
}
// Zone groups x vehicle-type columns of the SYSTEM availability grid: the warehouse's configured
// zones and vehicle types (same masters as the manual grid), plus any zone / type that appears in
// the data (e.g. ZONE NOT SET, kept last). Built from the masters - not only from the rows - so a
// day with no trucks, or a warehouse the source does not serve yet (MSILK), still shows every
// transporter against every zone with 0 instead of an empty grid.
// ON THE HUB TAB the groups are the HUBS instead of the zones - availability segregated per hub
// (client, 2026-10-16) - seeded from the hub master so every hub shows even with no trucks today.
systemGridLayout(){
    var transporters = this.feedRowsForTab();
    // The feed labels a hub truck with its plain SIZE ('32 FT Vehicle'), not the hub vehicle type,
    // so the Hub tab's columns are the REGULAR size list; '32 FT HUB Vehicle' and friends only
    // appear in the MANUAL hub grid, which is keyed off the hub vehicle master.
    var types = this.configuredVehicleTypes(this.state.is_hub ? "REGULAR" : this.state.manual_mode);
    var hubNames = this.state.hubNames || {};
    var isHubTab = !!this.state.is_hub;
    var order = [];
    var byZone = {};
    function add(zone, vt){
        if(!byZone[zone]){ byZone[zone] = []; order.push(zone); }
        if(vt && byZone[zone].indexOf(vt) < 0){ byZone[zone].push(vt); }
    }
    if(isHubTab){
        Object.keys(hubNames).forEach(function(k){
            types.forEach(function(vt){ add(hubNames[k], vt); });
        });
    } else {
        this.configuredZones().forEach(function(z){ types.forEach(function(vt){ add(z, vt); }); });
    }
    var self = this;
    transporters.forEach(function(r){
        if(r && r.zone !== undefined && r.zone !== null && r.vehicle_capacity){
            add(self.tabZoneLabel(r.zone), r.vehicle_capacity);
        }
    });
    order.sort(function(a, b){
        if(a === ZONE_NOT_SET_LABEL) return 1;
        if(b === ZONE_NOT_SET_LABEL) return -1;
        return a < b ? -1 : (a > b ? 1 : 0);
    });
    return order.map(function(z){ return { zone: z, types: byZone[z] }; });
}
createColumns(){
//    console.log("transdata ", this.state.transdata)
   var transporters = this.state.transdata;
   var columns = []
   // Width is a starting point only - onGridReady auto-sizes this column to its longest
   // transporter name. Suppressed like the rest so nothing stretches it to fill the grid.
   columns.push({
        headerName:"Transporter Name",
        field:"transporter_name",
        width:260,
        pinned:"left",
        resizable:true,
        suppressSizeToFit:true
    });

   // Count the vehicle-type columns first so they can be sized to the space available: a
   // warehouse with several zones x several vehicle types otherwise renders wide columns that
   // run off the right edge (and leave a gap when there are only a few).
   var layout = this.systemGridLayout();
   var childCount = 0;
   layout.forEach(function(g){ childCount += g.types.length; });
   var childWidth = zoneChildColumnWidth(childCount);

   layout.forEach(function(g){
        if(g.types.length === 0) return;
        columns.push({
            headerName: g.zone,
            marryChildren: true,
            children: g.types.map(function(k){
                return Object.assign({}, ZONE_VALUE_COL, {
                    headerName:k,
                    field:g.zone+ZONE_COL_SEP+k,
                    width:childWidth,
                    cellEditor: NumericCellEditor,
                });
            })
        });
   });
    var transactionId = this.state.transactionId;
    if(transactionId == '')
    {
        columns.push(Object.assign({}, ZONE_VALUE_COL, {
            headerName:"Total",
            field:"total",
            width:90
        }));
    }

    //console.log("columns ", columns)
    // Loader is hidden once, in onLoadShowData, after createRows() AND
    // getmanualvehicleavailability() have BOTH finished - not here. Hiding it
    // this early let the "system" grid flash on screen for a moment before
    // getmanualvehicleavailability's fire-and-forget fetch (now fixed to be
    // properly awaited) could swap in the "manual" grid for a warehouse
    // flagged for manual entry, which is what made the grid look broken/
    // half-rendered specifically on first load.
    //
    // The grid mounts on first render with only the hardcoded "Transporter
    // Name" column (before this fetch/build finishes). These are COLUMN
    // GROUPS (zone -> vehicle-type children) - neither letting the columnDefs
    // prop update flow through on its own, nor manually calling
    // gridApi.setColumnDefs()/sizeColumnsToFit() afterward, actually got the
    // grid to redraw the new group structure. The one thing that reliably
    // did was switching tabs, which unmounts and remounts the grid from
    // scratch - so force exactly that: bump gridInstanceKey, used as this
    // grid's React `key` in render, so React tears down the old grid
    // instance and mounts a fresh one with the real columns already in place.
    this.setState((prevState) => ({
        columnwithDefs:columns,
        gridInstanceKey: prevState.gridInstanceKey + 1,
    }))
}
createRows(){
    // Only the trucks of THIS tab: hub-zoned rows on the Hub tab, the rest everywhere else, so a
    // hub truck is counted once - under its hub - and never again in the regular zone view.
    var transdata = this.feedRowsForTab();
    var self = this;
    var rowdefs = []
    // console.log("transdata ", transdata)

    // The COLUMNS are the union of every (zone, vehicle type) across ALL transporters, but each
    // ROW used to carry only the keys that transporter happened to have a record for - so a
    // transporter with no row for, say, WEST/32 FT rendered a BLANK cell there while another
    // showed 0. Blank and 0 mean the same thing here (no truck available), and the mix reads as
    // "no data" vs "zero". Seed every row with 0 on every column key first, then overwrite with
    // the real counts. Display only - nothing is sent back from this grid.
    var allZoneTypeKeys = [];
    this.systemGridLayout().forEach(function(g){
        g.types.forEach(function(vt){ allZoneTypeKeys.push(g.zone + ZONE_COL_SEP + vt); });
    });

    var transportername = groupBy(transdata, rdata => rdata.transporter_name);
    transportername.forEach((trans, transkey) =>{
        var rows = {}
        rows.transporter_name=transkey
        allZoneTypeKeys.forEach(function(key){ rows[key] = 0; })
        var rowcnt = 0
        if(trans.length > 0)
        {
            var zones = groupBy(trans, rdata => rdata.zone);
            zones.forEach((wares,wkey) => {
                var capacities = groupBy(wares, rdata=>rdata.vehicle_capacity)
                //console.log("capacities ", capacities)
                capacities.forEach((wh,ky) => {
                   //console.log(wh.length,"wh.length")
                    if(wh.length == undefined)
                    {
                       var whLen = 0;
                    }
                    else{
                        var whLen = wh.length;
                    }
                    // tabZoneLabel, not the raw zone: on the Hub tab the count has to land on the
                    // hub's column group, which is spelled the way the hub master spells it.
                    rows[self.tabZoneLabel(wh[0].zone)+ZONE_COL_SEP+ky] = wh[0].vehicle_count
                    rowcnt = rowcnt+parseInt(wh[0].vehicle_count)
                })
            })
        }
        var transactionId = this.state.transactionId;
        if(transactionId == '')
        {
            rows["total"] = rowcnt
        }
        rowdefs.push(rows)
    })
    console.log("rowdefs ", rowdefs)
    this.setState({
        rowData:rowdefs,
    })
}
onGridReady = params => {
    this.gridApi = params.api;
    //console.log("Grid is: ", params);
    this.gridColumnApi = params.columnApi;
    // Both grid variants (system/manual - see render) sit inside a flex
    // container (flex:1, minHeight:0) and can mount/remount after the
    // surrounding layout has already settled (e.g. once
    // getmanualvehicleavailability decides which one to show) - without an
    // explicit resize, a freshly (re)mounted AG Grid in that kind of
    // container can render collapsed/blank until something else forces a
    // relayout (a window resize, a tab switch). Force one right away instead.
    setTimeout(() => {
        try {
            // Fit the Transporter Name column to its CONTENT, and leave every other column at its
            // declared width. sizeColumnsToFit() is deliberately NOT used on these grids: it
            // stretches columns proportionally to fill the grid, which inflated the count columns
            // (and then the name column, once they were suppressed) to absurd widths whenever a
            // warehouse had only a handful of zones. A grid narrower than its container is fine.
            params.columnApi.autoSizeColumns(["transporter_name"], false);
        } catch (e) { console.log(e); }
    }, 0);
};
// The Truck Details grid lives in a `display:none` panel until its tab is selected, so it is
// ALREADY MOUNTED - and zero-width - when onGridReady fires. autoSizeColumns() measures the
// rendered cells, so on a hidden grid it measures nothing and collapses "Transporter Name" to a
// sliver showing one character, which the user then has to drag open by hand. Its columns all
// carry explicit widths, so it simply does not need auto-sizing.
onGridReadyTruckDetails = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
};
onGridState = () =>{
        //console.log(this.gridApi);
    
        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();
                
        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
}



closeAlert = () => {
    this.setState({
        show: false
    });
}

onCellClicked(e)
{
    if(e.colDef.field == "container_no")
    {
        console.log(e.data.container_no);
    }
}

onClickHideAll(){
    this.setState({
    loadshow:'show-n',
    overly:'show-n',
    bulkslide:"",
    bulkslide1:"",
    selectedTransporter:{},
    
    });
    
}
showGrid(){
    this.setState({
        showCalendar : "show-n",
        showGridData  : "show-m"
    })
}

// The transaction-scoped SOB walk is gone (client, 2026-10-14): updateGridData() saved this
// grid and then redirected to /lmloadshare/<txn> to run SOB, and generateLoad() was already dead
// code calling generateLoadBySOB. Both removed with the "Assign Transporters" button. Manual
// availability is saved by this screen's own save, and SOB runs from the plan's SOB panel.
onClickTab(pageType){
    if(pageType == "partial")
    {
        var partial = "activet";
        var complete = "";
        var partialData = "";
        var completeData = "show-n";
        var showGridData = "show-m";
        var showGridData1 = "show-n";
        var pageClicked = 1;
    }
    else{
        var partial = "";
        var complete = "activet";
        var partialData = "show-n";
        var completeData = "";
        var showGridData = "show-n";
        var showGridData1 = "show-m";
        var pageClicked = 2;
    }
    // Switching between the two tabs only changes what is SHOWN. Reload a tab only when it has
    // not been loaded for this warehouse + planning type yet, or a change invalidated it
    // (_invalidateLoads) - it used to refetch everything, the external truck feed included, on
    // every click.
    if(this._loadedFor[pageClicked] !== this._loadKey()){
        this.pageAccess(pageClicked);
    } else if(pageClicked == 1){
        // Reusing loaded data: remount the availability grid now that it is visible again. A grid
        // (re)mounted while hidden behind Truck Details sizes its columns to zero width - the
        // pinned Transporter Name column collapsed to a sliver.
        this.setState((prev) => ({ gridInstanceKey: prev.gridInstanceKey + 1 }));
    }
    this.setState({
        partial: partial,
        complete: complete,
        partialData: partialData,
        completeData: completeData,
        showGridData: showGridData,
        showGridData1: showGridData1,
        pageType: pageClicked
    })
}
showBulkUpload(){
    this.setState({
        overly :"show-m",
        bulkslide : "slider-translate"
    })
}
showSingleUpload(){
    this.setState({
        overly :"show-m",
        bulkslide1 : "slider-translate"
    })
}
resetToLiveTrucks(){
    var cnf = window.confirm("Are you sure!!! You want to reset to live data?")
    if(cnf == true)
    {
        var reqParams = {
            loading_port_code : this.state.loading_port_code,
            data_type : this.state.data_type,
        }
        console.log("reqParams",reqParams)
        redirectURL.post("/lmconsignees/resetLmTrucksDetails",reqParams).then((response)=>{
            this.setState({
                basicTitle : "Success",
                basicType : "success",
                show : true,
                bulkslide:'',
                bulkslide1:'',
                overly:'show-n',
            })
            this._invalidateLoads();
            this.loadPageData();
            //window.location.reload();
        }).catch((e)=>{
            console.log(e);
        })
    }
}
resetUpload = () => {
    this.setState({
        bulkslide:'',
        bulkslide1:'',
        overly:'show-n',
        file:''
    });
    document.getElementById("upform").reset();
}
changeFileHandler = async (e) => {
    var dt = '';
    const config = {
        headers: [
            { 
                name: 'Transporter Name',
                inputName: 'transporter_name',
                required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'Transporter Code',
                inputName: 'transporter_code',
                required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'Vehicle Type',
                inputName: 'vehicle_type',
                required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            // { 
            //     name: 'Sequence No',
            //     inputName: 'sequence_no',
            //     required: true,
            //     requiredError: function (headerName, rowNumber, columnNumber) {
            //         return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
            //     }
            // },
            { 
                name: 'Vehicle Number',
                inputName: 'vehicle_number',
                required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'Punching Date',
                inputName: 'punching_date',
                required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            // { 
            //     name: 'Punching Time',
            //     inputName: 'punching_time',
            //     required: true,
            //     requiredError: function (headerName, rowNumber, columnNumber) {
            //         return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
            //     }
            // },                   
        ]
    }
    var data = CSVFileValidator(e.target.files[0], config)
    .then((csvData) => {
        this.setState({
            csvData:csvData.data
        });
        console.log(this.state.csvData,"csvData");
    })
    .catch(err => {})
    // console.log("e.target.files[0]",e.target.result);
    
    var out = new Promise(function(reject, resolve){
        var reader =  new FileReader();
        reader.onload = async function(e) {
            var contents = await e.target.result;
            resolve(contents);
        };
        var tt =  reader.readAsText(e.target.files[0]);
    });
    this.setState({
        file:e.target.files[0]
    });
    // console.log("e.target.files[0].type ", e.target.files[0]);

    if(e.target.files[0].type == '' ||e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel')
    {
        // console.log(fileData);
        // console.log(typeof(fileData))
        
    }
    else{
        e.target.value = null;
        this.setState({
            uploadFile:'',
            show: true, 
            basicType:'danger', 
            basicTitle:'Please upload file having extensions .csv only.',
        });
    }
    
}

uploadBulkFormHandler(event){
    event.preventDefault();
    var fileData = this.state.csvData;
    var flag=0;
    console.log(fileData,"fileData");
    
    if(flag == 0)
    {
        if(fileData.length > 0)
        {
            var reqParams = {
                loading_port_code : this.state.loading_port_code,
                data_type : this.state.data_type,
                csvData : fileData,
            }
            console.log("reqParams",reqParams)
            redirectURL.post("/lmconsignees/savebulkLmTrucksDetails",reqParams).then((response)=>{
                var resp=response.data.message;
                console.log(resp)
                this.setState({
                    basicTitle : resp,
                    basicType : "success",
                    show : true,
                    bulkslide:'',
                    bulkslide1:'',
                    overly:'show-n',
                })
                this._invalidateLoads();
                this.loadPageData();
                //window.location.reload();
            }).catch((e)=>{
                console.log(e);
            })
        }
        else
        {
            this.setState({
                basicTitle : "Invalid File",
                basicType : "warning",
                show : true,
            })
        }
        $('#upform')[0].reset();
    }
    else
    {
        $("#bulkUploadID").val();
        this.setState({
            basicTitle : "Fields Should not be Empty",
            basicType : "warning",
            show : true,
        })
        $('#upform')[0].reset();
    }
}
uploadSingleFormHandler(event){
    event.preventDefault();
    var vehicle_no = $("#vehicle_no").val();
    if(vehicle_no == undefined || vehicle_no == '')
    {
        vehicle_no = "unknown";
    }
    var vehicle_type = $("#vehicle_type").val();
    // Zone is mandatory for a manually added truck - see the form. Guarded here too, because the
    // browser's `required` only covers the form's own submit path.
    var truck_zone = $("#truck_zone").val();
    if(truck_zone === undefined || String(truck_zone).trim() === ""){
        this.setState({
            basicTitle : "Please select a Zone for the truck",
            basicType : "warning",
            show : true,
        });
        return;
    }
    var transporter = this.state.selectedTransporter;
    var transporter_code = "";
    var transporter_name = "";
    if(transporter !=undefined && transporter !='')
    {
        var transporter_code = transporter.value;
        var transporter_name = transporter.label;
    }
    var punching_date = $("#punching_date").val();
    var t = punching_date.split(" ");
    var ts = t[0].split("-")
    if(ts[2].length>2)
    {
        var tm = ts[2]+"-"+ts[1]+"-"+ts[0]+" "+t[1]+":00"
    }
    else
    {
        var tm = ts[0]+"-"+ts[1]+"-"+ts[2]+" "+t[1]+":00"
    }
    if(vehicle_type !=undefined && vehicle_type !='' && transporter_code !=undefined && transporter_code !='' && punching_date !=undefined && punching_date !='')
    {
        var reqParams = {
            loading_port_code : this.state.loading_port_code,
            data_type : this.state.data_type,
            vehicle_no : vehicle_no,
            vehicle_type : vehicle_type,
            transporter_code : transporter_code,
            transporter_name : transporter_name,
            punching_date : tm+":00",
            punching_original_date : punching_date,
            zone : truck_zone,
        }
        console.log("reqParams",reqParams)
        redirectURL.post("/lmconsignees/saveLmTrucksDetails",reqParams).then((response)=>{
            var resp=response.data.message;
            console.log(resp)
            this.setState({
                basicTitle : resp,
                basicType : "success",
                show : true,
                bulkslide:'',
                bulkslide1:'',
                selectedTransporter:{},
                overly:'show-n',
            })
            this._invalidateLoads();
            this.loadPageData();
            //window.location.reload();
        }).catch((e)=>{
            console.log(e);
        })
        $('#upform')[0].reset();
    }
    else
    {
        this.setState({
            basicTitle : "Fields Should not be Empty",
            basicType : "warning",
            show : true,
        })
    }
}
setSelectedTransporter(event){
    console.log(event)
    this.setState({
        selectedTransporter : event
    })
}
componentDidUpdate() {
    if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
        this._lastLoadingPortCode = this.context.loading_port_code;
        this.onGlobalPortChange();
    }
}
onGlobalPortChange = async () => {
    var selectedPlant = this.context.loading_port_code;
    if (!selectedPlant || !this.state.lpNames.some(each => each.loading_port_code == selectedPlant)) {
        // Not a valid port for this screen - keep this screen's own selection, don't refetch.
        return;
    }
    var pageType = this.state.pageType;
    await this.pageAccess(pageType);
}
// The TOP TAB is the mode (client, 2026-10-16) - Regular / Hub / Dedicated / Surface Courier.
// It carries the data_type everything is fetched with AND the hub flag, because Regular and Hub
// are both data_type 1. Was keyed on data_type alone; `mode` is now the single selection, so
// there is no second mode picker anywhere on the screen to disagree with it.
async onClickTab1(mode)
{
    var def = manualModeDef(mode);
    await this.setState({
        data_type : def.data_type,
        is_hub : def.hub === true,
        manual_mode : def.key,
    });
    // Reload the inner tab that is ON SCREEN; the other one reloads when opened (its
    // _loadedFor key no longer matches the new mode).
    if(this.state.pageType == 2){
        await this.loadPageData();
    } else {
        await this.onLoadShowData();
    }
}

onChangeManualVehicleAvailability = async() =>{
    var selectedPlant = this.state.loading_port_code;
    var mode = this.state.manual_mode;
    var modes = this.state.manual_modes;
    let newValue = !(modes[mode] && modes[mode].use === true);

    // Reflect the toggle immediately, for THIS mode (= this tab) only. The other three modes'
    // ticks are untouched, so Regular can run on manual counts while Dedicated stays on its feed.
    var nextModes = Object.assign({}, modes);
    nextModes[mode] = Object.assign({}, modes[mode], { use: newValue });
    await this.setState({
        manual_modes: nextModes,
        manual_vehicle_availability: newValue,
    });

    // Auto-save the flag against this warehouse + mode. AWAIT the persist BEFORE reloading —
    // onLoadShowData() re-reads the stored flag via getmanualvehicleavailability, so if the
    // save hasn't completed it would read the stale value and revert the toggle (previously
    // an untick did not stick after refresh).
    let params = {
        plant_code : selectedPlant,
        mode : mode,
        use_manual_vehicle_availability : newValue,
    }
    try {
        await redirectURL.post("/lmconsignees/updateusevehicleavailabilityornot", params);
    } catch(e) {
        console.log("updateusevehicleavailabilityornot failed", e);
    }

    // Refresh grid data now that the flag is persisted (reads the updated flag back). Untick =>
    // this tab goes back to the live feed, which was not fetched while manual was on, so the full
    // reload is needed; Truck Details lists the manual trucks too and must reload on its next visit.
    this._invalidateLoads();
    await this.onLoadShowData();
}

saveManualVehicleAvailabilty = () =>{
    var selectedPlant = this.state.loading_port_code;
    var mode = this.state.manual_mode;
    var modeState = (this.state.manual_modes || {})[mode] || { use:false, rows:[] };
    let manual_vehicle_availability = modeState.use === true;

    // Persist the "<zone>||<vehicle type>" cells as plain integers and drop the zeros, so the
    // stored document stays small and a blank cell is unambiguous. The grid writes strings while
    // editing, and the engine multiplies these counts - a "3" would expand into no trucks at all.
    // ⚠ Only the keys THIS mode renders are written. A legacy warehouse's single counts document
    // is resolved into EVERY mode (see resolveManualModes), so without this filter the first save
    // of the Regular grid would also store that document's HUB cells under Regular - the same
    // trucks counted twice once Hub is saved as well.
    var allowed = {};
    this.manualKeysForMode(mode).forEach(function(k){ allowed[k] = true; });
    var availData = (modeState.rows || []).map(function(row){
        var out = { transporter_name: row.transporter_name };
        Object.keys(row).forEach(function(key){
            if(key === "transporter_name" || !allowed[key]) return;
            var n = parseInt(row[key], 10);
            if(!isNaN(n) && n > 0) out[key] = n;
        });
        return out;
    });

    // Refuse counts the Transporters master does not back (the server refuses them too).
    var mapping = this.state.manualMapping;
    var unmapped = [];
    availData.forEach(function(row){
        Object.keys(row).forEach(function(key){
            if(key === "transporter_name" || key.indexOf(ZONE_COL_SEP) < 0) return;
            var zone = key.substring(0, key.indexOf(ZONE_COL_SEP));
            var vt = key.substring(key.indexOf(ZONE_COL_SEP) + ZONE_COL_SEP.length);
            if(!isManualCellAllowed(mapping, row.transporter_name, zone, vt)){
                unmapped.push(row.transporter_name + " / " + zone + " / " + vt + " (" + row[key] + ")");
            }
        });
    });
    if(unmapped.length > 0){
        this.setState({
            basicTitle : unmapped.length + " count(s) are not mapped in the Transporters master: "
                + unmapped.slice(0, 5).join("; ") + (unmapped.length > 5 ? "; ..." : "")
                + ". Set them to 0 (red cells) or map the transporter to that zone and vehicle type in Transporters.",
            basicType : "warning",
            show : true,
        });
        return;
    }

    // `mode` scopes the write to this mode's counts; the legacy flag is still sent so an older
    // server (and the legacy document) keeps behaving as it does today.
    // `available_on` is the DAY these counts are for - planning ignores them on any other day (see
    // manualEffectiveAvailableOn). `email` / `user_name` let the server stamp marked_by: a manual
    // count has no number plate, so who asserted it is the only provenance it will ever have.
    var modeStateForSave = (this.state.manual_modes || {})[mode] || {};
    var params = {
        plant_code : selectedPlant,
        mode : mode,
        use_manual_vehicle_availability : manual_vehicle_availability,
        availabilitydata:availData,
        available_on : modeStateForSave.available_on_input || istToday(),
        email : localStorage.getItem("email") || "",
        user_name : localStorage.getItem("username") || ""
    }
    redirectURL.post("/lmconsignees/savemanualvehicleavailability",params)
    .catch((e) => {
        var msg = (e && e.response && e.response.data && e.response.data.message) ? e.response.data.message : "";
        this.setState({ basicTitle : msg || "Someting went wrong", basicType : "warning", show : true });
        return null;
    })
    .then((response) => {
        if(!response) return;
        var res = response.data.message;
        console.log(res,'sre')
        if(res == 'success'){
            // Truck Details lists the manual trucks - refetch it on its next visit.
            this._invalidateLoads();
            // Re-read the document so the date, "Marked on / by" and the stale banner reflect
            // what the SERVER stored rather than what this screen assumes it stored - otherwise a
            // stale warning would survive the very save that cleared it.
            this.getmanualvehicleavailability();
            this.setState({
                basicTitle : "Data Saved Successfully",
                basicType : "success",
                show : true,
            })
        }else{
            this.setState({
                basicTitle : "Someting went wrong",
                basicType : "warning",
                show : true,
            })
        }
    })
    
}

getmanualvehicleavailability = async () =>{
    // Rows are keyed "<zone>||<vehicle type>" so ONE transporter row can hold counts for several
    // zones. Legacy documents stored a plain "<vehicle type>" key with no zone at all - those are
    // folded into the ZONE NOT SET group (blank zone = usable in any zone), so an existing
    // warehouse keeps its saved numbers after this change. See normaliseManualRows.
    // ⚠ Do NOT put `mode` in this request body: the server uses the body as its Mongo filter, so
    // a mode key would match no document. ONE document is read and split into the four modes here
    // (resolveManualModes), which is also why switching mode needs no fetch at all.
    var params = {
        plant_code : this.state.loading_port_code,
    }
    // Which cells the Transporters master backs - loaded alongside the counts so the grid can
    // grey out the rest, and AWAITED with them: the row list of a never-configured mode falls
    // back to whatever transporter names we know, and a half-applied mapping would flash cells
    // as allowed and then grey them. A failure leaves it null (nothing greyed); the save is
    // still checked server-side. Same mapping for every mode - it spans all planning tabs.
    var mapping = null;
    var doc = null;
    await Promise.all([
        redirectURL.post("/lmconsignees/getManualAvailabilityMapping", params)
            .then((resp) => { mapping = (resp && resp.data) ? (resp.data.mapping || null) : null; })
            .catch((e) => { console.log("getManualAvailabilityMapping failed", e); }),
        // Was fire-and-forget (no return) - callers doing
        // `await this.getmanualvehicleavailability()` resolved immediately,
        // before this fetch/setState actually finished. That let onLoadShowData
        // hide the loading overlay and reveal the "system" grid, which this then
        // swapped out for the "manual" grid a moment later once the request
        // landed - a mid-render grid-instance swap that's a well-known cause of
        // a blank/collapsed AG Grid inside a flex layout. Awaited here so the
        // caller actually waits for this to settle first.
        redirectURL.post("/lmconsignees/getmanualvehicleavailability", params)
            .then((response) => {
                var res = response.data;
                if(Array.isArray(res) && res.length > 0) doc = res[0];
            })
            .catch((e) => { console.log(e); }),
    ]);

    // Mapping first, so the row builders below see it in state.
    await this.setState({ manualMapping: mapping });
    var resolved = resolveManualModes(doc);          // per-mode, legacy document falls back
    var modes = {};
    MANUAL_MODE_KEYS.forEach((k) => {
        modes[k] = {
            use: resolved[k].use,
            rows: this.normaliseManualRows(k, resolved[k].data),
            // Stored date + provenance, and the picker's starting value derived from them. Reset
            // on every (re)load on purpose: this function runs after a save and after a warehouse
            // change, and an in-progress date edit must not survive either - it would then be
            // shown against another warehouse's counts, or against counts already stamped.
            effective_on: resolved[k].effective_on,
            available_on_input: defaultAvailableOnInput(resolved[k].effective_on),
            marked_at: resolved[k].marked_at,
            marked_by: resolved[k].marked_by,
        };
    });
    await this.setState({
        manual_modes: modes,
        // Always default each mode's checkbox to its stored flag, so a ticked mode shows its
        // Manual Availability view by default - independent of whether counts were saved.
        // This copy tracks the tab on screen only (the loaders read it before manual_modes lands).
        manual_vehicle_availability: modes[this.state.manual_mode].use === true,
        gridInstanceKey: this.state.gridInstanceKey + 1,
    });
}

  render() {
      var loading_port_code = this.state.loading_port_code;
      var hideAxle = true;
      if(loading_port_code == "RPDCGUR")
      {
        hideAxle = false;
      }

      // Vehicle columns come from the warehouse's own master (see configuredVehicleTypes), not a
      // fixed list, so this grid and the system-availability grid show the same set of types.
      // Manual Availability grid: ZONE column groups, each with the warehouse's vehicle types
      // underneath - the same shape as the system-availability grid.
      // ⚠ A transporter can hold trucks in SEVERAL zones, so zone cannot be one value per ROW
      // (an earlier build had a single Zone dropdown per transporter, which silently forced a
      // transporter into exactly one zone). The count lives per (zone, vehicle type) cell instead.
      // PER MODE = PER TOP TAB: the grid rendered is the one for the tab on screen, built from
      // that mode's own groups - zones x its vehicle types, or the HUB groups on the Hub tab.
      var manualMode = this.state.manual_mode;
      var manualModeState = (this.state.manual_modes || {})[manualMode] || { use:false, rows:[] };
      var manualGroups = this.manualGroupsForMode(manualMode);
      var manualMapping = this.state.manualMapping;
      var manualCellCount = manualGroups.reduce(function(n, g){ return n + g.types.length; }, 0);
      // The manual counts grid is offered ONLY while this tab's tick is on (client, 2026-10-16).
      // Unticked, the tab shows the normal system/feed view - the tick is what declares that this
      // mode is run off manual counts, so an unticked tab must not present an editable grid that
      // planning would ignore. The tick is per mode, so each tab answers this on its own.
      var showManualGrid = manualModeState.use === true;
      // One editable count cell for (zone or hub, vehicle type).
      var manualCountCol = function(zone, vt){
          return Object.assign({}, ZONE_VALUE_COL, {
              headerName: vt,
              field: zone + ZONE_COL_SEP + vt,
              width: zoneChildColumnWidth(manualCellCount),
              filter: false,
              // Only cells the Transporters master backs take a count. An unbacked cell that
              // already HOLDS a count (saved before this check) stays editable so it can be set to 0.
              editable: function(params){
                  if(isManualCellAllowed(manualMapping, params.data.transporter_name, zone, vt)) return true;
                  // ⚠ AG Grid passes NO `value` to an editable callback - read the count off the row.
                  var n = parseInt(params.data ? params.data[zone + ZONE_COL_SEP + vt] : NaN, 10);
                  return !isNaN(n) && n > 0;
              },
              cellStyle: function(params){
                  if(isManualCellAllowed(manualMapping, params.data.transporter_name, zone, vt)){
                      return availabilityCellStyle(params);
                  }
                  var n = parseInt(params.value, 10);
                  return (!isNaN(n) && n > 0)
                      ? { backgroundColor: "#fde2e2", color: "#c62828" }
                      : { backgroundColor: "#f1f1f1", color: "#b0b0b0" };
              },
              tooltipValueGetter: function(params){
                  return isManualCellAllowed(manualMapping, params.data.transporter_name, zone, vt) ? null
                      : "Not mapped in Transporters master for " + zone + " / " + vt;
              },
              cellEditor: NumericCellEditor,
              valueParser: function(params){
                  var n = parseInt(params.newValue, 10);
                  return isNaN(n) || n < 0 ? 0 : n;
              },
          });
      };
      var manualupdatecolumnDefs = [
        {
            headerName: "Transporter Name",
            field: "transporter_name",
            width:260,                  // starting point; auto-sized to content on grid ready
            pinned: "left",
            filter: true,
            resizable: true,
            suppressSizeToFit: true,
            editable:false,
            // A name that only survives from an older saved document (or a renamed transporter)
            // has no Transporters master row here - none of its counts can be used.
            valueFormatter: function(params){
                return isManualTransporterKnown(manualMapping, params.value)
                    ? params.value : params.value + "  (not in Transporters master)";
            },
            cellStyle: function(params){
                return isManualTransporterKnown(manualMapping, params.value) ? null : { color: "#c62828" };
            },
        },
      ].concat(
        // One group per zone (or per hub in HUB mode) - headers, keys and the ZONE NOT SET /
        // hub-SOB semantics all live in manualGroupsForMode, which the save and the blank-row
        // seeding read too, so the grid can never render one set of cells and store another.
        manualGroups.map(function(g){
            return {
                headerName: g.header,
                marryChildren: true,
                children: g.types.map(function(vt){ return manualCountCol(g.zone, vt); })
            };
        })
      );

    var columnwithDefsForTruck = [
        {
            headerName: "Transporter Name",
            field: "transporter_name",
            width:180,
            filter: true,
            resizable: true,
            editable:false,            
        },
        {
            headerName: "Transporter Code",
            field: "transporter_code",
            width:130,
            filter: true,
            resizable: true,
            editable:false,            
        },
        {
            headerName: "Vehicle Type",
            field: "vehicle_type",
            width:150,
            filter: true,
            resizable: true,
            editable:false,
        },
        {
            // Zone the LSP earmarked the truck for at punching time. Blank = not earmarked, which
            // planning treats as usable in any zone.
            headerName: "Zone",
            field: "zone",
            width:140,
            filter: true,
            resizable: true,
            editable:false,
        },
        {
            // Where the row came from. Manual-availability rows are SYNTHETIC (one per counted
            // truck, cloned from the transporter's last real punch), which is why they carry
            // vehicle-0/1/2 numbers and an old punching date - without this column they read as
            // mysterious "random" trucks.
            headerName: "Source",
            field: "source",
            width:120,
            filter: true,
            resizable: true,
            editable:false,
        },
        {
            headerName: "Axle Type",
            field: "axle_type",
            width:150,
            filter: true,
            resizable: true,
            editable:false,
            hide:hideAxle
        },
        // {
        //     headerName: "Sequence No",
        //     field: "sequence_no",
        //     width:130,
        //     filter: true,
        //     resizable: true,
        //     editable:false,
        // },
        {
            headerName: "Vehicle Number",
            field: "vehicle_number",
            width:130,
            filter: true,
            resizable: true,
            editable:false,
            cellClass:"cellstylegrid"
        },
        {
            headerName: "Punching Date",
            field: "punching_date",
            width:150,
            filter: true,
            resizable: true,
            editable:false,
            valueGetter : function(params){
                if(params.data.punching_date !=undefined && params.data.punching_date !='')
                {
                    return getHyphenDDMMYYYYHHMMSS(params.data.punching_date);
                }
            }
        },
        // {
        //     headerName: "Punching Time",
        //     field: "punching_time",
        //     width:140,
        //     filter: true,
        //     resizable: true,
        //     editable:false,
        // },
    ];
    var userroles = localStorage.getItem("roles")
    return (
      <div class="container-fluid d-flex flex-column" style={{height: "100%"}}>
        <SweetAlert
            show={this.state.show}
            type={this.state.basicType}
            title={this.state.basicTitle}
            onConfirm={this.closeAlert}
        >
        </SweetAlert>

        <div className="row" style={{marginBottom:"10px", flexShrink: 0}}>
            <div className="col-sm-12">
                <ul
                    style={{
                        display: "inline-flex",
                        flexWrap: "wrap",
                        padding: "4px",
                        margin: 0,
                        listStyle: "none",
                        gap: "4px",
                        backgroundColor: "#ffffff",
                        borderRadius: "10px",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
                    }}
                >
                    {/* THE TAB IS THE MODE - Regular / Hub / Dedicated / Surface Courier (client,
                        2026-10-16). There is no separate Manual Availability mode picker: the
                        "Use Manual Availability" tick and the counts grid below belong to
                        whichever tab is selected here. Hub is data_type 1 + the hub flag, so it
                        cannot be driven off data_type alone (see MANUAL_MODES). Surface Courier
                        stays behind lm_FullAccess exactly as before; a ticked mode shows a dot,
                        so the manual state of the other tabs is readable without opening them. */}
                    {MANUAL_MODES.filter((m) => (m.key !== "COURIER" || userroles.indexOf("lm_FullAccess") >= 0))
                    .map((m) => {
                        var isActive = this.state.manual_mode === m.key;
                        var modeOn = !!(this.state.manual_modes[m.key] && this.state.manual_modes[m.key].use);
                        return (
                            <li key={m.key} onClick={this.onClickTab1.bind(this, m.key)} style={{ listStyle: "none" }}>
                                <button
                                    type="button"
                                    title={modeOn ? "Manual availability is ON for " + m.label
                                                  : "Live truck availability for " + m.label}
                                    style={{
                                        whiteSpace: "nowrap",
                                        border: "none",
                                        outline: "none",
                                        borderRadius: "999px",
                                        padding: "8px 18px",
                                        fontSize: "13px",
                                        fontWeight: isActive ? 600 : 500,
                                        cursor: "pointer",
                                        transition: "all 0.2s ease",
                                        backgroundColor: isActive ? "#1976d2" : "transparent",
                                        color: isActive ? "#fff" : (modeOn ? "#2e7d32" : "#555"),
                                        boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                    }}
                                >
                                    {(modeOn ? "● " : "") + m.label}
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>

        <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", flex: "1 1 0%", display: "flex", flexDirection: "column", minHeight: 0 }}>
            <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", flexShrink: 0 }}>
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Truck Availability</h5>
                </div>
                <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}></div>
            </div>
            <div className="col-xl-12 col-lg-12" style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", minHeight: 0, padding: "0 18px 18px 18px" }}>
                <div className="d-flex justify-content-between align-items-end" style={{marginBottom:"10px", flexShrink: 0}}>
                    <ul
                        style={{
                            display: "inline-flex",
                            flexWrap: "wrap",
                            padding: "4px",
                            margin: 0,
                            listStyle: "none",
                            gap: "4px",
                            backgroundColor: "#f4f6f8",
                            borderRadius: "10px"
                        }}
                    >
                        {[
                            { key: "partial", label: "Truck Availability", active: this.state.partial },
                            { key: "complete", label: "Truck Details", active: this.state.complete },
                        // Truck Details is hidden while "Use Manual Availability" is on: it would
                        // only re-list the manual counts as made-up vehicle numbers, and Add Truck /
                        // Reset To Live Trucks do not apply. The manual grid is the source then.
                        // PER MODE now: the question is answered by the tick of the TAB on screen
                        // (state.manual_vehicle_availability tracks state.manual_mode), so Truck
                        // Details disappears on a ticked Regular tab and is still there on an
                        // unticked Dedicated one.
                        ].filter(({ key }) => !(key === "complete" && this.state.manual_vehicle_availability === true))
                        .map(({ key, label, active }) => {
                            var isActive = active == "activet";
                            return (
                                <li key={key} onClick={this.onClickTab.bind(this,key)} style={{ listStyle: "none" }}>
                                    <button
                                        type="button"
                                        style={{
                                            whiteSpace: "nowrap",
                                            border: "none",
                                            outline: "none",
                                            borderRadius: "999px",
                                            padding: "8px 18px",
                                            fontSize: "13px",
                                            fontWeight: isActive ? 600 : 500,
                                            cursor: "pointer",
                                            transition: "all 0.2s ease",
                                            backgroundColor: isActive ? "#1976d2" : "transparent",
                                            color: isActive ? "#fff" : "#555",
                                            boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                        }}
                                    >
                                        {label}
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                    {this.state.partial == "activet" ?
                    /* The tick belongs to the TAB above - no mode suffix is needed, the tab says
                       which mode this is. It is per mode, so ticking Regular and Hub while
                       leaving Dedicated unticked means exactly that. Save appears only while the
                       tick is on, because that is the only state in which the counts grid is on
                       screen at all. */
                    /* ONE row (client, 2026-10-19): the controls used to be stacked in a vertical
                       column-reverse block, so the warning made the toolbar several lines tall and
                       pushed the grid down while the tab pills sat at its bottom-left above empty
                       space. The warning now lives in a full-width strip under the toolbar. */
                    <div className='d-flex align-items-center justify-content-end' style={{ gap: "14px", flexWrap: "wrap" }}>
                    {showManualGrid && (manualModeState.marked_at || manualModeState.marked_by) ?
                        <span style={{ fontSize: "11px", color: "#64748b" }}>
                            Marked on {formatMarkedAt(manualModeState.marked_at) || "-"}
                            {manualModeState.marked_by ? " by " + manualModeState.marked_by : ""}
                        </span> : ""}
                    {/* "Available on" - the ONE day these counts are for, like a punching date.
                        Planning ignores them on any other day, so a count can no longer sit in the
                        document for ever being offered to every future plan. Shown only with the
                        grid: a date on counts nobody can see or edit would mean nothing. */}
                    {showManualGrid ?
                        <div className="d-flex align-items-center" style={{ gap: "6px", fontSize: "12px" }}>
                            <span>Available on</span>
                            <input type="date" value={manualModeState.available_on_input || istToday()}
                                   min={istToday()}
                                   onChange={(e) => {
                                       var v = e.target.value;
                                       var all = Object.assign({}, this.state.manual_modes || {});
                                       all[manualMode] = Object.assign({}, all[manualMode] || {}, { available_on_input: v });
                                       this.setState({ manual_modes: all });
                                   }} />
                        </div> : ""}
                    <label className="d-flex align-items-center" style={{ margin: 0 }}><input onClick={this.onChangeManualVehicleAvailability} name="manual_vehicle_availability" checked={manualModeState.use === true} value={manualModeState.use === true} type="checkbox"/>&nbsp;Use Manual Availability</label>
                    {showManualGrid ? <button type='button' className="pill-btn pill-btn-success" onClick={this.saveManualVehicleAvailabilty}>Save</button> : ''}
                    </div>
                    : ""}
                    {this.state.complete == "activet" ?
                    <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                        {(this.state.pageAccess != 2) ?
                        <button className="pill-btn pill-btn-info" onClick={this.resetToLiveTrucks.bind(this)}>Reset To Live Trucks</button>
                        : ""}
                        {/* "+ Add Truck" is HIDDEN (client decision, 2026-09-29).
                            A truck added here is written to `lmtruckavailabilitydetails`, which
                            the SCREEN counts (both this tab and the availability grid) but the
                            PLANNING ENGINE never reads - db_get_available_vehicles goes to the
                            manual counts or straight to the autometrics feed, and the only
                            function that ever read that collection
                            (dbcalls.old_db_get_available_vehicles) is dead code with no callers.
                            So adding trucks here raised the on-screen numbers while the plan
                            ignored them. The form, its handler and saveLmTrucksDetails are left
                            intact: restore this button once those trucks are actually fed into
                            availability (union with the portal feed, de-duped on vehicle number).
                        {(this.state.pageAccess != 2) ?
                        <button className="pill-btn pill-btn-success" onClick={this.showSingleUpload.bind(this)}>+ Add Truck</button>
                        : ""} */}
                    </div>
                    : ""}
                </div>
                {/* Stale = the STORED counts are dated a day other than today, so planning is
                    not using them right now - the mode has fallen back to its normal supply.
                    Judged off effective_on (the server's own fallback chain), never off the
                    date picker: the picker is what the NEXT save will write, not what is live. */}
                {this.state.partial == "activet" && showManualGrid && manualModeState.effective_on
                 && manualModeState.effective_on !== istToday() ?
                    renderNoticeStrip("warn",
                        "These counts are dated " + moment(manualModeState.effective_on, "YYYY-MM-DD").format("DD-MMM-YYYY")
                        + " and are NOT being used by planning today. Check them and Save to mark them for today.")
                    : ""}
                {/* Dedicated / Courier SOB never reads the live feed: with manual off it assigns the
                    transporter from the Approved SOB share (sob_utils fabricates the trucks), with
                    manual on it uses the counts. So the feed grid on these tabs is reference only. */}
                {((this.state.partial == "activet" && !showManualGrid) || this.state.complete == "activet")
                 && (manualMode === "DEDICATED" || manualMode === "COURIER") ?
                    renderNoticeStrip("info",
                        (manualMode === "DEDICATED" ? "Dedicated" : "Surface Courier") + " SOB does not use the live truck feed - it assigns"
                        + " transporters from the Approved SOB share, or from Manual Availability counts when ticked."
                        + " The trucks below are for reference only.")
                    : ""}
                {this.state.partial == "activet" && !showManualGrid ? renderIgnoredTrucksNotice(this.state.feedIgnored, this.state.loading_port_code) : ""}
                {this.state.complete == "activet" ? renderIgnoredTrucksNotice(this.state.truckIgnored, this.state.loading_port_code) : ""}
                {/* The system (live feed) view is what a tab shows unless ITS OWN tick is on -
                    on the Hub tab that feed is the hub-zoned trucks, grouped per hub. */}
                {!showManualGrid ?
                <div className={"ag-theme-balham grid-wrapper mb-3 "+this.state.showGridData} style={{ flex: 1, minHeight: 0 }}>
                    <AgGridReact
                        key={this.state.gridInstanceKey}
                        modules={this.state.modules}
                        columnDefs={this.state.columnwithDefs}
                        defaultColDef={{
                            sortable: true,
                            filter: true,
                            floatingFilter: true, resizable: true
                        }}
                        rowData={this.state.rowData}
                        enableCharts={false}
                        // autoGroupColumnDef={this.state.autoGroupColumnDef}
                        onGridReady={this.onGridReady}
                        onGridState={this.onGridState}
                        frameworkComponents={this.state.frameworkComponents}
                        statusBar={{
                            statusPanels: [
                                { statusPanel: "agSelectedRowCountComponent", align: "left" },
                                { statusPanel: "agFilteredRowCountComponent", align: "center" },
                                { statusPanel: "agTotalRowCountComponent", align: "right" }
                            ]
                        }}
                        sideBar={this.state.sideBar}
                        stopEditingWhenGridLosesFocus= {true}
                        paginationPageSize={this.state.paginationPageSize}
                        pagination={false}
                        gridOptions={{
                            context: { componentParent: this }
                        }}
                        // components={this.state.components}
                        enableRangeSelection= {true}
                        animateRows
                        rowHeight={45}
                        headerHeight={45}
                        //onCellClicked={this.onCellClicked}
                        // onCellEditingStopped={this.onCellUpdateData.bind(this)}
                    />
                </div>
                :
                <React.Fragment>
                {/* Explains the greyed / red cells (Transporters master check on manual counts). */}
                <div className={this.state.showGridData} style={{ fontSize: "12px", color: "#555", margin: "0 0 6px 2px" }}>
                    <span style={{ display: "inline-block", width: "12px", height: "12px", backgroundColor: "#f1f1f1",
                                   border: "1px solid #ccc", verticalAlign: "middle", marginRight: "6px" }}></span>
                    Greyed-out cell: transporter is not mapped to that zone &amp; vehicle type in Transporters master - count not allowed.
                    <span style={{ display: "inline-block", width: "12px", height: "12px", backgroundColor: "#fde2e2",
                                   border: "1px solid #e8a3a3", verticalAlign: "middle", margin: "0 6px 0 14px" }}></span>
                    Red: set it to 0 to save.
                </div>
                {/* A mode whose vehicle master is empty would render a one-column grid that looks
                    broken; name the master to fix instead. */}
                {manualCellCount > 0 ? "" :
                <div className={this.state.showGridData} style={{ fontSize: "12px", color: "#c62828", margin: "0 0 6px 2px" }}>
                    No {manualMode === "HUB" ? "hub vehicle types" : "vehicle types"} are configured for {manualMode} at
                    this warehouse - add them in Vehicle Details ({manualMode === "HUB" ? "Hub" : manualMode} tab) first.
                </div>}
                <div className={"ag-theme-balham grid-wrapper mb-3 "+this.state.showGridData} style={{ flex: 1, minHeight: 0 }}>
                    <AgGridReact
                        key={"manual-" + manualMode + "-" + manualupdatecolumnDefs.length + "-" + this.state.gridInstanceKey}
                        modules={this.state.modules}
                        columnDefs={manualupdatecolumnDefs}
                        defaultColDef={{
                            sortable: true,
                            filter: true,
                            floatingFilter: true, resizable: true
                        }}
                        rowData={manualModeState.rows}
                        enableCharts={false}
                        // autoGroupColumnDef={this.state.autoGroupColumnDef}
                        onGridReady={this.onGridReady}
                        onGridState={this.onGridState}
                        frameworkComponents={this.state.frameworkComponents}
                        statusBar={{
                            statusPanels: [
                                { statusPanel: "agSelectedRowCountComponent", align: "left" },
                                { statusPanel: "agFilteredRowCountComponent", align: "center" },
                                { statusPanel: "agTotalRowCountComponent", align: "right" }
                            ]
                        }}
                        sideBar={this.state.sideBar}
                        // stopEditingWhenGridLosesFocus= {true}
                        paginationPageSize={this.state.paginationPageSize}
                        pagination={false}
                        gridOptions={{
                            context: { componentParent: this }
                        }}
                        enableRangeSelection= {true}
                        animateRows
                        rowHeight={45}
                        headerHeight={45}
                    />

                </div>
                </React.Fragment>
                }
                <div style={{ display: this.state.showGridData1 === "show-m" ? "flex" : "none", flexDirection: "column", flex: 1, minHeight: 0 }}>
                    <div className="ag-theme-balham grid-wrapper" style={{ flex: 1, minHeight: 0 }}>
                        <AgGridReact
                            modules={this.state.modules}
                            columnDefs={columnwithDefsForTruck}
                            defaultColDef={{
                                sortable: true,
                                filter: true,
                                floatingFilter: true, resizable: true
                            }}
                            rowData={this.state.truckData}
                            enableCharts={false}
                            // autoGroupColumnDef={this.state.autoGroupColumnDef}
                            onGridReady={this.onGridReadyTruckDetails}
                            onGridState={this.onGridState}
                            frameworkComponents={this.state.frameworkComponents}
                            statusBar={{
                                statusPanels: [
                                    { statusPanel: "agSelectedRowCountComponent", align: "left" },
                                    { statusPanel: "agFilteredRowCountComponent", align: "center" },
                                    { statusPanel: "agTotalRowCountComponent", align: "right" }
                                ]
                            }}
                            sideBar={this.state.sideBar}
                            stopEditingWhenGridLosesFocus= {true}
                            paginationPageSize={this.state.paginationPageSize}
                            pagination={false}
                            gridOptions={{
                                context: { componentParent: this }
                            }}
                            // components={this.state.components}
                            enableRangeSelection= {true}
                            animateRows
                            rowHeight={45}
                            headerHeight={45}
                            //onCellClicked={this.onCellClicked}
                            // onCellEditingStopped={this.onCellUpdateData.bind(this)}
                        />
                    </div>
                </div>
            </div>
        </div>

        {/* <button className="btn btn-success" onClick={this.formAssignHandler.bind(this)} style={{marginLeft:"91em"}}>Insert Exports</button> */}
        <div className={`hub-slider ${this.state.bulkslide ? "open" : ""} d-flex flex-column`}>

            <div className="slider-header">
                Bulk Upload
                <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer" }}>✕</span>
            </div>

            <form method="POST" id="upBulkform" className="theme-form d-flex flex-column flex-grow-1" style={{ minHeight: "0px" }} onSubmit={this.uploadBulkFormHandler}>
                <div className="slider-body flex-grow-1" style={{ minHeight: "0px" }}>

                    <label className="m-0">Upload File<span className="text-danger">*</span></label>
                    <input type="file" name="uploadFile" id="bulkUploadID" onChange={this.changeFileHandler} className="mb-2" required />

                    <div>
                        <a className="pill-btn pill-btn-primary" href={require('../../assets/json/sample_lmtruckdetails.csv')} target="_blank">Sample Template</a>
                    </div>

                </div>
                <div className="slider-footer">
                    <button type="button" onClick={this.resetUpload.bind(this)} className="pill-btn mr-2" style={{ backgroundColor: "#eceff1", color: "#455a64" }}>Cancel</button>
                    <button type="submit" className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px" }}>Submit</button>
                </div>
            </form>
        </div>
        <div className={`hub-slider ${this.state.bulkslide1 ? "open" : ""} d-flex flex-column`}>

            <div className="slider-header">
                Add Truck
                <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer" }}>✕</span>
            </div>

            <form method="POST" id="upform" className="theme-form d-flex flex-column flex-grow-1" style={{ minHeight: "0px" }} onSubmit={this.uploadSingleFormHandler}>
                <div className="slider-body flex-grow-1" style={{ minHeight: "0px" }}>

                    <label className="m-0">Vehicle No</label>
                    <input type="text" name="vehicle_no" id="vehicle_no" className="mb-2" />

                    <label className="m-0">Vehicle Type<span className="text-danger">*</span></label>
                    <select name="vehicle_type" id="vehicle_type" className="form-control mb-2" required>
                        <option value="">Select Vehicle Type</option>
                        {/* Deduped: lmvehiclecapacity is keyed by (warehouse, ZONE), so the raw
                            list repeats every type once per zone. */}
                        {this.configuredVehicleTypes().map(function(vt){
                            return <option key={vt} value={vt}>{vt}</option>
                        })}
                    </select>

                    <label className="m-0">Zone<span className="text-danger">*</span></label>
                    {/* Mandatory: a truck added here is a real, physical truck, so the zone it is
                        earmarked for is known. (A BLANK zone still exists in the data model - it is
                        what the portal sends for a truck the LSP has not earmarked yet - but it is
                        not something a user should be able to choose.) */}
                    <select name="truck_zone" id="truck_zone" className="form-control mb-2" required>
                        <option value="">Select Zone</option>
                        {this.configuredZones().map(function(z){
                            return <option key={z} value={z}>{z}</option>
                        })}
                    </select>

                    <label className="m-0">Transporter<span className="text-danger">*</span></label>
                    <Select
                        placeholder={"Select Transporter"}
                        //isMulti={true}
                        closeMenuOnSelect={true}
                        classNamePrefix="react-select" className="mb-2"
                        onChange={this.setSelectedTransporter.bind(this)}
                        options={this.state.lmtransporters} required
                    />

                    <label className="m-0">Punching Time<span className="text-danger">*</span></label>
                    <input
                    type="text"
                    placeholder="Punching Time"
                    id="punching_date"
                    name="punching_date"
                    //  onChange={this.handlerStartDateTime.bind(this)}
                    className="datetimepicker_mask form-control" required />

                </div>
                <div className="slider-footer">
                    <button type="button" onClick={this.resetUpload.bind(this)} className="pill-btn mr-2" style={{ backgroundColor: "#eceff1", color: "#455a64" }}>Cancel</button>
                    <button type="submit" className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px" }}>Submit</button>
                </div>
            </form>
        </div>
        <div className={"dataLoadpage " +(this.state.loadshow)}>
        </div>
        <div className={"dataLoadpageimg " +(this.state.loadshow)}>
            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
        </div>
        <div className={"overlay-part "+(this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
      </div>

    );
  }
}

function loadDateTimeScript(){
	var currentTime = new Date().getTime();
    var todayDate = new Date().getDate();
    var logic = function( currentDateTime ){
        // console.log("currentDateTime ", new Date(currentDateTime).getDate())
        // console.log("todayDate ", todayDate)
        var clickdate = new Date(currentDateTime).getDate()
        if( clickdate == todayDate ){
          this.setOptions({
            minTime:currentTime,
            timepickerScrollbar: true,
            scrollInput:true
          });
        }
        else
        {
            this.setOptions({
                minTime:"00:00",
                timepickerScrollbar: true,
                scrollInput:true
            });
        }
          
      };
	$('.datetimepicker_mask').datetimepicker({
		format:'Y-m-d H:i',
        formatTime:"H:i A",
        minTime:currentTime,
        onChangeDateTime:logic,
        onShow:logic,
        minDate : new Date(new Date().setDate(todayDate)),
        maxDate: new Date(new Date().setDate(todayDate + 2)),
        startDate:new Date(new Date().setDate(todayDate)),
        timepickerScrollbar: true,
        scrollInput:true
	});
    var index  =window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src="https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
	//script.src="http://xdsoft.net/jqplugins/datetimepicker/"
	script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}

function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
         const key = keyGetter(item);
         const collection = map.get(key);
         if (!collection) {
             map.set(key, [item]);
         } else {
             collection.push(item);
         }
    });
    return map;
}

function NumericCellEditor() {
}

// gets called once before the renderer is used
NumericCellEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');

    if (isCharNumeric(params.charPress)) {
        this.eInput.value = params.charPress;
    } else {
        if (params.value !== undefined && params.value !== null) {
            this.eInput.value = params.value;
        }
    }

    var that = this;
    this.eInput.addEventListener('keypress', function (event) {
        if (!isKeyPressedNumeric(event)) {
            that.eInput.focus();
            if (event.preventDefault) event.preventDefault();
        } else if (that.isKeyPressedNavigation(event)) {
            event.stopPropagation();
        }
    });

    // only start edit if key pressed is a number, not a letter
    var charPressIsNotANumber = params.charPress && ('1234567890'.indexOf(params.charPress) < 0);
    this.cancelBeforeStart = charPressIsNotANumber;
};

function getCharCodeFromEvent(event) {
    event = event || window.event;
    return (typeof event.which == "undefined") ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
    return !!/\d/.test(charStr);
}

// function isCharDecimal(charStr) {
//     return !!/\./.test(charStr);
// }

function isKeyPressedNumeric(event) {
    const charCode = getCharCodeFromEvent(event);
    const charStr = String.fromCharCode(charCode);
    //return isCharNumeric(charStr) || isCharDecimal(charStr);
    return isCharNumeric(charStr);
}

NumericCellEditor.prototype.isKeyPressedNavigation = function (event) {
    return event.keyCode === 39
        || event.keyCode === 37;
};


// gets called once when grid ready to insert the element
NumericCellEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
NumericCellEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
};

// returns the new value after editing
NumericCellEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
};

// example - will reject the number if it contains the value 007
// - not very practical, but demonstrates the method.
NumericCellEditor.prototype.isCancelAfterEnd = function () {
    var value = this.getValue();
    return value.indexOf('007') >= 0;
};

// returns the new value after editing
NumericCellEditor.prototype.getValue = function () {
    return this.eInput.value;
};

// any cleanup we need to be done here
NumericCellEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could  even leave this method out as it's optional
};

// if true, then this editor will appear in a popup 
NumericCellEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};
